__webpack_require__.p = "/management/_next/";